import { render, staticRenderFns } from "./coursemanagement.vue?vue&type=template&id=281301cc&scoped=true"
import script from "./coursemanagement.vue?vue&type=script&lang=js"
export * from "./coursemanagement.vue?vue&type=script&lang=js"
import style0 from "./coursemanagement.vue?vue&type=style&index=0&id=281301cc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "281301cc",
  null
  
)

export default component.exports